import PatientsIncompleteInfoContainer from './patients-incomplete-info-container';

export default PatientsIncompleteInfoContainer;
